var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, Button, Heading, Image, Layer, Paragraph, ResponsiveContext } from "grommet";
import styled from "styled-components";
import { IconSvg } from "../../IconSvg";
var CloseButton = styled(Button)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 60px;\n  height: 60px;\n  border-top-right-radius: 20px;\n  background-color: #000000;\n",
    ]))
);
export var LargePopup = function LargePopup(_ref) {
  var image = _ref.image,
    subtext = _ref.subtext,
    heading = _ref.heading,
    closePopup = _ref.closePopup,
    button = _ref.button,
    paragraph = _ref.paragraph;
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Layer,
        {
          onClickOutside: closePopup,
          onEsc: closePopup,
          full: true,
          background: "transparent",
          animation: "fadeIn",
          position: "center",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            fill: true,
            background: "rgba(196, 196, 196, 1)",
            align: "center",
            justify: "start",
            style: {
              position: "relative",
              visibility: "visible",
            },
            overflow: "auto",
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              width: "1038px",
              background: {
                color: "site-colors-1",
              },
              round: "20px",
              style: {
                position: "absolute",
              },
            },
            /*#__PURE__*/ React.createElement(
              Box,
              {
                flex: true,
                direction: "row",
              },
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  height: "321px",
                },
                /*#__PURE__*/ React.createElement(Image, {
                  src: image,
                  fit: "cover",
                  style: {
                    borderRadius: "20px 20px 0 0",
                  },
                })
              ),
              /*#__PURE__*/ React.createElement(
                CloseButton,
                {
                  onClick: closePopup,
                },
                /*#__PURE__*/ React.createElement(
                  Box,
                  {
                    align: "center",
                  },
                  /*#__PURE__*/ React.createElement(IconSvg, {
                    src: "close",
                  })
                )
              )
            ),
            /*#__PURE__*/ React.createElement(
              Box,
              {
                pad: {
                  vertical: "32px",
                  horizontal: "large",
                },
                color: "black",
              },
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  gap: "16px",
                  pad: {
                    bottom: "40px",
                  },
                },
                /*#__PURE__*/ React.createElement(
                  Paragraph,
                  {
                    size: "medium",
                    style: {
                      textTransform: "uppercase",
                    },
                    fill: true,
                  },
                  subtext
                ),
                /*#__PURE__*/ React.createElement(
                  Heading,
                  {
                    level: 1,
                    style: {
                      textTransform: "uppercase",
                    },
                  },
                  heading
                ),
                /*#__PURE__*/ React.createElement(
                  Paragraph,
                  {
                    size: "1rem",
                    style: {
                      lineHeight: "24px",
                    },
                  },
                  paragraph
                ),
                /*#__PURE__*/ React.createElement(
                  Paragraph,
                  {
                    size: "1rem",
                    style: {
                      lineHeight: "24px",
                    },
                  },
                  paragraph
                )
              ),
              /*#__PURE__*/ React.createElement("hr", {
                style: {
                  paddingBottom: "1px",
                  backgroundColor: "#B4BBC7",
                  width: "100%",
                  borderRadius: "100px",
                },
              }),
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  flex: true,
                  direction: "row",
                  justify: "between",
                  pad: {
                    top: "20px",
                  },
                },
                /*#__PURE__*/ React.createElement(
                  Box,
                  null,
                  /*#__PURE__*/ React.createElement(
                    Button,
                    {
                      href: "",
                      style: {
                        backgroundColor: "black",
                        border: "none",
                        padding: "6px 32px",
                        borderRadius: "30px",
                      },
                    },
                    /*#__PURE__*/ React.createElement(
                      Paragraph,
                      {
                        size: "0.75rem",
                        style: {
                          textAlign: "center",
                          color: "white",
                          textTransform: "uppercase",
                          lineHeight: "24px",
                        },
                      },
                      button
                    )
                  )
                )
              )
            )
          )
        )
      );
    })
  );
};
